import Query from '../../../components/Report';

const query = new Query('search-urls-directories-total-clicks');

export default query;
